/**
 * Accordion Content Formatter
 * Автоматически форматирует текст в аккордеонах для лучшей читаемости
 */
(function() {
  function cleanMsoHtml(html) {
    // 1. Удаляем сломанные MSO теги (с пробелом после <)
    // Паттерн: < span...>, < b...>, < /span>, etc.
    html = html.replace(/<\s+(\/?)(\w+)([^>]*)>/gi, '');

    // 1.5. Удаляем MSO условные комментарии
    html = html.replace(/<!--\s*\[if[^\]]*\][\s\S]*?<!\[endif\]\s*-->/gi, '');
    html = html.replace(/<!--\[endif\]-->/gi, '');

    // 1.6. Удаляем MSO комментарии без закрывающего тега (вариант без endif)
    html = html.replace(/<!--\s*\[if[^\]]*\]-->/gi, '');

    // 1.7. Удаляем вложенные span-ы с пробелами/&nbsp; (MSO нумерация)
    // Паттерн: <span><span>2.<span>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></span>
    // Результат: 2.
    html = html.replace(/<span[^>]*><span[^>]*>(\d+\.)<span[^>]*>[&nbsp;\s]*<\/span><\/span><\/span>/gi, '$1 ');

    // 2. Удаляем MSO нумерацию типа "1.font: 7.0pt 'Times New Roman';\">"
    html = html.replace(/"\d+\.font:[^"]*">/gi, '');

    // 3. Удаляем оставшиеся MSO style-фрагменты
    html = html.replace(/\s*style="[^"]*mso-[^"]*"/gi, '');
    html = html.replace(/\s*style="[^"]*font:\s*\d+(\.\d+)?pt[^"]*"/gi, '');

    // 4. Удаляем атрибуты lang и class с mso
    html = html.replace(/\s*lang="[^"]*"/gi, '');
    html = html.replace(/\s*class="Mso[^"]*"/gi, '');

    // 5. Удаляем пустые span теги
    html = html.replace(/<span[^>]*>\s*<\/span>/gi, '');

    return html;
  }

  function splitIntoParagraphs(content) {
    const paragraphs = content.querySelectorAll('p');

    paragraphs.forEach(function(p) {
      const text = p.textContent.trim();

      // Если параграф длинный и содержит несколько предложений
      if (text.length > 200) {
        // Разбиваем по точке + пробел (но не по сокращениям типа "g/m².")
        const sentences = text.split(/(?<=[.!?])\s+(?=[A-ZÄÖÜ])/);

        if (sentences.length >= 3) {
          // Группируем по 2 предложения
          const groups = [];
          for (let i = 0; i < sentences.length; i += 2) {
            groups.push(sentences.slice(i, i + 2).join(' '));
          }

          // Заменяем содержимое
          const newHtml = groups.map(function(g) { return '<p>' + g + '</p>'; }).join('');
          p.outerHTML = newHtml;
        }
      }
    });
  }

  function formatAccordionContent() {
    const accordionContents = document.querySelectorAll('.accordion__content.rte');

    accordionContents.forEach(function(content) {
      if (content.dataset.formatted === 'true') return;

      let html = content.innerHTML;

      // 1. Очищаем MSO HTML
      html = cleanMsoHtml(html);

      // 1.5. Нормализуем нумерованные элементы с strong
      // Паттерн: "2. <strong><span>Name</span></strong>" -> "2. Name"
      html = html.replace(/(\d+\.)\s*<strong[^>]*><span[^>]*>([^<]+)<\/span><\/strong>/gi, '$1 $2');
      html = html.replace(/(\d+\.)\s*<strong[^>]*>([^<]+)<\/strong>/gi, '$1 $2');

      // 2. Удаляем "!!!" из начала текста
      html = html.replace(/^(\s*<p>)?\s*!!!\s*/i, '$1');

      content.innerHTML = html;

      // 3. Разбиваем длинные параграфы на читаемые блоки
      splitIntoParagraphs(content);

      // 4. Форматируем параграфы
      const paragraphs = content.querySelectorAll('p');

      paragraphs.forEach(function(p) {
        let pHtml = p.innerHTML;

        // Protect HTML tags from being modified by the label regex
        var tagPlaceholders = [];
        pHtml = pHtml.replace(/<[^>]+>/g, function(tag) {
          tagPlaceholders.push(tag);
          return '\x00TAG' + (tagPlaceholders.length - 1) + '\x00';
        });

        // Оборачиваем текст с двоеточием в span
        // Исключаем CSS-подобные строки (с = " - перед :)
        pHtml = pHtml.replace(/(<strong>)?([A-Za-zÄÖÜäöüß][A-Za-zÄÖÜäöüß\s]{2,30}:)(<\/strong>)?(?=\s|$)/g, function(match, openTag, text, closeTag) {
          // Пропускаем если похоже на CSS/атрибут
          if (text.includes('=') || text.includes('"') || text.includes('-')) {
            return match;
          }
          if (openTag) {
            return '<strong class="accordion-label">' + text.trim() + '</strong> ';
          }
          return '<span class="accordion-label">' + text.trim() + '</span> ';
        });

        // Restore HTML tags
        pHtml = pHtml.replace(/\x00TAG(\d+)\x00/g, function(match, idx) {
          return tagPlaceholders[parseInt(idx)];
        });

        // Выделяем нумерованные элементы вида "1. Название –"
        // Пропускаем если уже обработано (есть accordion-label)
        if (pHtml.indexOf('accordion-label') === -1) {
          // Добавлены: - (дефис), ; (для HTML entities), . (для сокращений)
          // Учитываем возможные span-ы между названием и тире
          pHtml = pHtml.replace(/^(\d+\.\s*)([A-Za-zÄÖÜäöüß&;.\-][A-Za-zÄÖÜäöüß&;.\-\s]+?)(<span[^>]*>)?\s*(–)/g, function(match, num, name, spanTag, dash) {
            return '<span class="accordion-label">' + num + name.trim() + '</span> ' + (spanTag || '') + dash;
          });
        }

        p.innerHTML = pHtml;
      });

      content.dataset.formatted = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatAccordionContent);
  } else {
    formatAccordionContent();
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.accordion summary')) {
      setTimeout(formatAccordionContent, 100);
    }
  });
})();
